import React from "react";
import { GraduationCap, Award, Megaphone, Users, Trophy, Star, Check } from "lucide-react";
import { usd } from "../lib/api";

export const PACKAGE_BENEFITS = {
  single: [
    [GraduationCap, "Full camp scholarship for 1 child"],
    [Award, "1 commemorative Sporting Camps scarf"],
    [Megaphone, "Sponsor acknowledgment during camp"],
  ],
  community: [
    [GraduationCap, "Full camp scholarships for 2 children"],
    [Award, "2 commemorative Sporting Camps scarves"],
    [Megaphone, "Enhanced sponsor recognition during camp"],
    [Users, "Acknowledgment on Sporting Camps social media"],
  ],
  champions: [
    [GraduationCap, "Full camp scholarships for 5 children"],
    [Award, "5 commemorative Sporting Camps scarves"],
    [Megaphone, "Premium sponsor recognition during camp"],
    [Users, "Featured acknowledgment on Sporting Camps social media"],
    [Trophy, "Special recognition during the closing ceremony"],
    [Star, "Designation as a Presenting Scholarship Sponsor for the camp"],
  ],
};

function PackageCard({ pkg, selected, onSelect }) {
  return (
    <button
      type="button"
      data-testid={`sponsor-package-${pkg.key}`}
      onClick={() => onSelect(pkg.key)}
      className={`relative text-left rounded-2xl bg-white border-2 overflow-hidden shadow-lg shadow-emerald-950/5 transition-[transform,border-color] duration-200 hover:-translate-y-1 ${selected ? "border-[#008057] ring-4 ring-[#008057]/15" : "border-[#E2EBF0]"}`}
    >
      <div className="bg-[#03281B] text-white px-6 pt-6 pb-5">
        <div className="font-display text-2xl font-extrabold uppercase leading-tight">{pkg.name}</div>
        <div className="w-8 h-0.5 bg-[#F3C242] my-3" />
        <div className="text-xs uppercase tracking-[0.18em] text-white/70">{pkg.tagline}</div>
      </div>
      <div className="bg-gradient-to-r from-[#E9D49A] to-[#F3E3B3] px-6 py-4 flex items-center gap-3">
        <span data-testid={`sponsor-package-price-${pkg.key}`} className="font-display text-3xl font-extrabold text-[#03281B]">{usd(pkg.price)}</span>
        <span className="text-[11px] uppercase tracking-widest text-[#03281B]/80 leading-tight border-l border-[#03281B]/30 pl-3">Support<br />{pkg.children} young athlete{pkg.children > 1 ? "s" : ""}</span>
      </div>
      <ul className="px-6 py-5 space-y-3">
        {(PACKAGE_BENEFITS[pkg.key] || []).map(([Icon, text]) => (
          <li key={text} className="flex items-start gap-3 text-sm text-slate-700"><Icon size={18} className="text-[#008057] shrink-0 mt-0.5" /> {text}</li>
        ))}
      </ul>
      {selected && <span className="absolute top-4 right-4 w-7 h-7 rounded-full bg-[#F3C242] text-[#03281B] flex items-center justify-center"><Check size={16} /></span>}
    </button>
  );
}

export function SponsorPackages({ packages, selectedKey, onSelect }) {
  return (
    <div data-testid="sponsor-packages" className="grid md:grid-cols-3 gap-6 items-start">
      {packages.map((p) => <PackageCard key={p.key} pkg={p} selected={p.key === selectedKey} onSelect={onSelect} />)}
    </div>
  );
}
